import { today } from '../core/format/dates'
import { firstSource } from '../core/rules/acquisition'
import { db } from './db'
import type { SourceAskedAt } from '../core/types/insights'

/**
 * DEMO — zoals de server: alleen het eerste antwoord op "Hoe kwam je bij ons?" komt bij de klant
 * (core/rules/acquisition.ts). Een ongeldig antwoord doet niets; een aanvraag mislukt er nooit op.
 */
export function recordCustomerSource(customerId: string | undefined, source: unknown, via: SourceAskedAt) {
  if (!customerId || !source) return
  db.changeAccount(customerId, (a) => {
    const next = firstSource(a.customer.acquisitionSource, source, today(), via)
    return next === a.customer.acquisitionSource ? [a, null] : [{ ...a, customer: { ...a.customer, acquisitionSource: next } }, null]
  })
}
